module.exports = __webpack_public_path__ + "static/img/szdwm.2e14f8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/szdwm.png
// module id = 3uQt
// module chunks = 1